// @flow
import styled from 'styled-components';

export const DayPriceWrap = styled.div`
  font-size: 1.2rem;
  color: ${props => (props.label ? props.theme.color.black : props.theme.color.primaryAccent)};
  text-align: center;
  margin: 0.5rem 0;
`;
